module.exports = __webpack_public_path__ + "img/left_2.c9f79354.jpg";